import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

//material
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';

//components
import { NavigationDialogComponent } from 'src/app/shared/dialogs/navigation-dialog/navigation-dialog.component';

//constants
import { AttributeValuesConstants } from 'src/app/shared/constants';

//helpers
import { BindingCardHelper } from 'src/app/shared/helpers';

//models
import { BindingCardModel } from 'src/app/shared/models';

@Component({
  selector: 'lotta-header',
  imports: [
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  readonly dialog = inject(MatDialog);
  private bindingCard: BindingCardModel | null = null;

  //private
  private _bindingCard!: Subscription;

  ngOnInit(): void {
    this._bindingCard = BindingCardHelper.bindingCard.subscribe(res => {
      this.bindingCard = res;
    });
  }

  openNavigation(): void {
    this.dialog.open(NavigationDialogComponent, {
      panelClass: [AttributeValuesConstants.FULL_HEIGHT_DIALOG, AttributeValuesConstants.NAVIGATION_DIALOG],
      data: {
        uuid: this.bindingCard?.binding_uuid
      }
    });
  }

  ngOnDestroy(): void {
    if (this._bindingCard) this._bindingCard.unsubscribe();
  }
}
